import { Checkbox, Text, Thumbnail } from '@wix/design-system';
import React, { FC } from 'react';
import styles from './SelectionCard.scss';

type Props = {
  title: string;
  description?: string;
  icon: React.ReactNode;
  onClick?: () => void;
  isSelected?: boolean;
  selectionType?: 'single' | 'multiple';
};

export const SelectionCard: FC<Props> = ({
  title,
  description,
  icon,
  onClick,
  isSelected,
  selectionType = 'single',
}) => {
  return (
    <Thumbnail onClick={onClick} selected={isSelected} hideSelectedIcon={selectionType === 'multiple'}>
      <div className={styles.selectionCard}>
        {selectionType === 'multiple' && (
          <div className={styles.selectionCardHead}>
            <Checkbox checked={isSelected} />
          </div>
        )}
        <div className={styles.selectionCardContent}>
          <Text weight="normal">{title}</Text>
          {description && (
            <Text secondary size="small">
              {description}
            </Text>
          )}
        </div>
        <div className={styles.selectionCardTail}>{icon}</div>
      </div>
    </Thumbnail>
  );
};
